export type MarginType = 'chamfer' | 'shoulder' | 'deep-chamfer'

export type MaterialId = 'fmc' | 'pfm' | 'emax' | 'zirconia'

export type MaterialStandard = {
  id: MaterialId
  label: string
  fullName: string
  occlusalClearanceMm: number
  axialReductionMm: number
  margin: string
  marginType: MarginType
  color: number
  note: string
}

export const MATERIAL_STANDARDS: readonly MaterialStandard[] = [
  {
    id: 'fmc',
    label: 'FMC',
    fullName: '全部金属冠',
    occlusalClearanceMm: 1,
    axialReductionMm: 0.5,
    margin: 'シャンファー',
    marginType: 'chamfer',
    color: 0xc49a45,
    note: '金属の強度を活かし、切削量を抑えた形成です。',
  },
  {
    id: 'pfm',
    label: 'PFM',
    fullName: '陶材焼付金属冠',
    occlusalClearanceMm: 2,
    axialReductionMm: 1.2,
    margin: 'ショルダー',
    marginType: 'shoulder',
    color: 0x789bb2,
    note: '金属と陶材の厚みを確保するため、十分な削除量を取ります。',
  },
  {
    id: 'emax',
    label: 'e.max',
    fullName: '二ケイ酸リチウム冠',
    occlusalClearanceMm: 1.5,
    axialReductionMm: 1,
    margin: 'ディープシャンファー',
    marginType: 'deep-chamfer',
    color: 0x65b6c6,
    note: 'セラミックの厚みと滑らかな応力移行を両立します。',
  },
  {
    id: 'zirconia',
    label: 'ジルコニア',
    fullName: 'モノリシックジルコニア冠',
    occlusalClearanceMm: 1,
    axialReductionMm: 0.5,
    margin: 'シャンファー',
    marginType: 'chamfer',
    color: 0xa5bbc0,
    note: '材料強度を活かし、必要な厚みを保ちながら形成量を抑えます。',
  },
] as const

export function getMaterialStandard(id: MaterialId): MaterialStandard {
  const standard = MATERIAL_STANDARDS.find((candidate) => candidate.id === id)
  if (!standard) throw new Error(`Unknown material standard: ${id}`)
  return standard
}
